
import { Options, Vue } from 'vue-class-component';
import { BraSquareMeterConfigurationClient } from '@/services/Services';
import UploadBraExcelModal from '../modals/uploadBraExcelModal.vue';
import * as OM from '@/Model';

@Options({
    components: {}
})
export default class braConfig extends Vue {

    configurations: OM.BraSquareMeterCombinationsConfig[] = [];

    created() {
        this.init();
    }

    init() {
        BraSquareMeterConfigurationClient.getConfigurationList()
        .then(x => {
            this.configurations = x;
        })
    }

    uploadExcelModal() {
        this.$opModal.show(UploadBraExcelModal, {
            callback: () => {
                this.$opModal.closeLast();
                this.init();
            }
        })
    }

}
